import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import _ from 'lodash'

// 基底コンポーネント
// import '@/components/_globals';

// moment
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
// Element-ui
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/ja'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/css/ccs-ui.css'
// VeeValidate
import VeeValidate, { Validator } from 'vee-validate'
import VeeValidateJaLocale from 'vee-validate/dist/locale/ja'
// logger
import logger from '@/utils/logger.js'
// loading service
import loadingService from '@/utils/loadingService.js'
// notification
import notification from '@/utils/notification.js'

import '@fortawesome/fontawesome-free/css/fontawesome.min.css'
import '@fortawesome/fontawesome-free/css/solid.min.css'
import AsyncComputed from 'vue-async-computed'

// couldn't caught exception
// TODO: ログ通知 共通処理を追加予定 ccsErrors[x].canIgnoreを見てログを保存するか判定すること
Vue.config.errorHandler = (err, vm, info) => {
  console.error(`Captured in Vue.config.errorHandler: ${info}`, err)
}
window.addEventListener('error', event => {
  // 'ResizeObserver loop limit exceeded'を無視する
  if (event.message === 'ResizeObserver loop limit exceeded') return
  console.error('Captured in error EventListener', event, event.error, (event.error || {}).ccsErrors)
})
window.addEventListener('unhandledrejection', event => {
  console.error('Captured in unhandledrejection EventListener', event, event.reason, (event.reason || {}).ccsErrors)
})

Validator.localize('ja', VeeValidateJaLocale)
Vue.use(VeeValidate, { locale: 'ja', fieldsBagName: 'vvFields' })
Vue.use(ElementUI, { locale, zIndex: 200000 })
Vue.use(VueMoment, { moment })
Vue.use(logger, {
  level: process.env.NODE_ENV === 'production' ? logger.LOG_LEVEL_ERROR : logger.LOG_LEVEL_DEBUG
})
Vue.use(loadingService)
Vue.use(notification)
Vue.use(AsyncComputed)

Vue.prototype.$isFunctionDisabled = (funcId) => {
  return store.getters.confirmAuthority(funcId).disabled
}
Vue.prototype.$isFunctionShown = (funcId) => {
  return store.getters.confirmAuthority(funcId).display
}

Vue.filter(
  /**
   * formatter
   * @param {*} value
   * @param {String} type フォーマットタイプ
   * @param {String} dateFormat 日付型フォーマット typeがDateの場合のみ有効.
   * @param {Number} fractionDigits 数値型の小数点以下の桁数. typeがNumberの場合のみ有効.
   * @param {Boolean} comma 数値をコンマ区切りにするかどうか. typeがNumberの場合のみ有効.
   */
  'formatter', function (value, type, { dateFormat = 'YYYY/MM/DD HH:mm', fractionDigits = 0, comma = true } = {}) {
    if (!value) {
      return value
    }
    let result = ''
    switch (type) {
      case 'Number':
        result = parseFloat(value).toFixed(fractionDigits)
        return isNaN(result)
          ? value
          : comma ? commaSeparator(result) : result
      case 'Date':
        if (Array.isArray(value)) {
          let results = []
          value.forEach((item) => results.push(Vue.moment.utc(item).tz(store.state.timeZone).format(dateFormat)))
          return results.find((item) => item === 'Invalid date') ? value : results.join(' - ')
        } else {
          result = Vue.moment.utc(value).tz(store.state.timeZone).format(dateFormat)
          return result.toString() === 'Invalid date' ? value : result
        }
      default:
        return value
    }
  }
)

Vue.filter(
  /**
   * value が 数値の場合、コンマ区切りにして返却する.
   * type に Number 以外が指定されている場合、何もせずに返却する.
   * @param {*} value
   */
  'comma', function (value, type = null) {
    if (!value) {
      return ''
    }
    if (!type || type === 'Number') {
      return isNaN(value) ? value : commaSeparator(value)
    } else {
      return value
    }
  }
)
const commaSeparator = function (val) {
  let split = _.split(val, '.')
  split[0] = split[0].replace(/(\d)(?=(\d{3})+$)/g, '$1,')
  return split.join('.')
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js